import React, { Component } from "react";

import AlertRow from "./AlertRow";

import { withStyles } from '@material-ui/core/styles';
//import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Box from '@material-ui/core/Box';

const styles = theme => ({
	[theme.breakpoints.down('sm')]:{
		bigcell: {
			maxWidth:'150px',
			minWidth:'50px'
		},
		medcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
		smallcell: {
			maxWidth:'15px',
			minWidth:'15px'
		},
	},
	[theme.breakpoints.up('md')]:{
		bigcell: {
			maxWidth:'150px',
			minWidth:'50px'
		},
		medcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
		smallcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
	},
	setoverflow:{
		overflow:'hidden',
		display: 'block'
	}
});
class AlertList extends Component {
	constructor(props) {
        super(props);
		this.state= {
			page: 0,
			rowsPerPage: 25,
		}
		this.handleSolveAlert=this.handleSolveAlert.bind(this);
		this.handleFirstPageButtonClick=this.handleFirstPageButtonClick.bind(this);
		this.handleBackButtonClick=this.handleBackButtonClick.bind(this);
		this.handleNextButtonClick=this.handleNextButtonClick.bind(this);
		this.handleLastPageButtonClick=this.handleLastPageButtonClick.bind(this);
		this.handleChangePage=this.handleChangePage.bind(this);
		this.handleChangeRowsPerPage=this.handleChangeRowsPerPage.bind(this);
    }
	
	handleFirstPageButtonClick(event) {
		this.setState({page: 0});
	}
	
	handleBackButtonClick(event) {
		this.setState({page: this.state.page-1});
	}
	
	handleNextButtonClick(event) {
		this.setState({page: (this.state.page+1 > Math.max(0, Math.ceil(this.props.alertRecords.length / this.state.rowsPerPage) - 1)) ? this.state.page : this.state.page+1});
	}
	
	handleLastPageButtonClick(event) {
		this.setState({page: Math.max(0, Math.ceil(this.props.alertRecords.length / this.state.rowsPerPage) - 1)});
	}
  
	handleChangePage(event, newPage) {
		this.setState({page: newPage});
	}
	
	handleChangeRowsPerPage(event) {
		this.setState({ rowsPerPage: parseInt(event.target.value, 10),
						page: 0
		});
	}
	handleSolveAlert(alertId){
		//console.log("AlertList.handleSolveAlert: "+alertId);
		this.props.handleSolveAlert(alertId);
	}

	render() {
		var user;
//		console.log(this.props);
    	const rows = [];
		let count=0;
    	if(this.props.alertRecords && this.props.alertRecords.length>0){
			count = this.props.alertRecords.length;
			for (var j = this.state.rowsPerPage*this.state.page; (j < (this.state.rowsPerPage*(this.state.page+1))) && (j<this.props.alertRecords.length); j++) {
//				console.log("nonconformity ["+j+"]:"+JSON.stringify(this.props.alertRecords[j]));
				user="";
				rows.push(
				<AlertRow
					key={this.props.alertRecords[j].id}
					id={this.props.alertRecords[j].id}
					message={this.props.alertRecords[j].message}
					reference=""
					date={this.props.alertRecords[j].date}
					active={this.props.alertRecords[j].active}
					handleSolveAlert={this.handleSolveAlert}/>
				);
			}
		}
		
		return (
		<div className="content">
		  <Table stickyHeader className="lst">
		    <TableHead>
		      <TableRow>
				<TableCell>ID</TableCell>
				<TableCell>Message</TableCell>
				<TableCell>Referance</TableCell>
				<TableCell>Date</TableCell>
				<TableCell>Status</TableCell>
		      </TableRow>
		    </TableHead>
		    <TableBody>{rows}</TableBody>
		    <TableFooter>
              <TableRow>
                <TablePagination
                  colSpan={11}
                  count={count}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
		  </Table>
		</div>
		);
  }
};

export default withStyles(styles)(AlertList);